import { KIND_UNIQ_SYMBOL } from '@API/helpers/v2_helpers';

export const getMinMaxColumnsCount = (columnsNames: string[]) => {
  return columnsNames.filter(name => name.includes(KIND_UNIQ_SYMBOL)).length;
};
